import React from "react";
import OpenBottomSheet from "../OpenBottomSheet";
import arrowUP from "../assets/icons/arrow-up.svg";
import arrowSwap from "../assets/icons/arrow-swap.svg";

import { useState } from "react";

export default function Actions() {
  const buy_content = <div className="containerx pt-10 text-white">
    <h2 className="text-2xl font-bold pb-5 ">Buy coins</h2>
    <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
        <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
    <button className="w-full bg-[#007A5D] hover:bg-teal-900 duration-300 p-3 text-white rounded-md">sub</button>
  </div>

const sell_content = <div className="containerx pt-10 text-white">
<h2 className="text-2xl font-bold pb-5 ">Sell coins</h2>
<input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
        <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
    <button className="w-full bg-[#007A5D] hover:bg-teal-900 duration-300 p-3 text-white rounded-md">sub</button>
</div>


const swap_content = <div className="containerx pt-10 text-white">
    <h2 className="text-2xl font-bold pb-5 ">Swap coins</h2>
    <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
        <input className="mb-2 bg-[#212323] w-full p-4 focus:outline-none text-white placeholder-[#6C6C6C] text-sm rounded-md" placeholder="Enter amount" type="text" name="" id="" />
    <button className="w-full bg-[#007A5D] hover:bg-teal-900 duration-300 p-3 text-white rounded-md">sub</button>
  </div>



  const [openBuy, setOpenBuy] = useState(false);
  const [openSell, setOpenSell] = useState(false);
  const [openSwap, setOpenSwap] = useState(false);
  
//   useEffect(() => {
//     if (openPopup === true) {
//     //   setOpenPopup(false);

//       setTimeout(() => {
//           setOpenPopup(false)

//         }, 1000);
//     }
//   }, [openPopup]);

//   const handleChange = () => {
//     setOpenPopup(false)
//   }

const handleClick = (action) => {
    
    if(action === "buy") {
       setOpenBuy(true)
    }

    if(action === "sell") {
        setOpenSell(true)
     }

     if(action === "swap") {
        setOpenSwap(true)
     }


    // setOpenPopup(true)
    

}
  return (





    <div className="top-section containerx">



      <OpenBottomSheet setOpenPopup={setOpenBuy} openPopup={openBuy} sheetContent={buy_content} />

      <OpenBottomSheet setOpenPopup={setOpenSell} openPopup={openSell} sheetContent={sell_content} />

      <OpenBottomSheet setOpenPopup={setOpenSwap} openPopup={openSwap} sheetContent={swap_content} />
        
          

      

      <div className="actions-panel mt-7 flex gap-5 ">
      <div className="action-button max-w-fit flex flex-col items-center">
          
         
          <div
            onClick={() => handleClick("buy")}
            className="action-button-icon p-4 rounded-full bg-zinc-800 duration-300 hover:bg-zinc-700"
          >
            <img src={arrowUP} alt="" />
          </div>
          <p>buy</p>
        </div>


        <div className="action-button max-w-fit flex flex-col items-center">
          
        
          
          <div
            onClick={() => handleClick("sell")}
            className="action-button-icon p-4 rounded-full bg-zinc-800 duration-300 hover:bg-zinc-700"
          >
            <img src={arrowUP} className="rotate-180" alt="" />
          </div>
          <p>sell</p>
        </div>


        <div className="action-button max-w-fit flex flex-col items-center">
          
        
          
          <div
            onClick={() => handleClick("swap")}
            className="action-button-icon p-4 rounded-full bg-zinc-800 duration-300 hover:bg-zinc-700"
          >
            <img src={arrowSwap} alt="" />
          </div>
          <p>swap</p>
        </div>

        {/* <div className="action-button max-w-fit flex flex-col items-center">
          <div
            onClick={(e) => {e.preventDefault(); setOpenPopup(true)}}
            className="action-button-icon p-4 rounded-full bg-zinc-800 duration-300 hover:bg-zinc-700"
          >
            <OpenBottomSheet setOpenPopup={setOpenPopup} openPopup={openPopup} sheetContent={sell_content} />
            <img src={arrowUP} className="rotate-180" alt="" />
          </div>
          <p>sell</p>
        </div>

        <div className="action-button max-w-fit flex flex-col items-center">
          <div
            onClick={(e) => {e.preventDefault(); setOpenPopup(true)}}
            className="action-button-icon p-4 rounded-full bg-zinc-800 duration-300 hover:bg-zinc-700"
          >
            <OpenBottomSheet setOpenPopup={setOpenPopup} openPopup={openPopup} sheetContent={swap_content} />
            <img src={arrowSwap} alt="" />
          </div>
          <p>swap</p>
        </div> */}




      </div>


      


    </div>
  );
}
